/**
 * Step 1 wording for the live item previews (pd7). The rest of the step's copy lives in
 * `constants/distributionHelpContent.ts`.
 */
export const SPLIT_STEP_PREVIEW_COPY = {
  /** The placeholder's accessible name while an item's data loads. */
  loading: "Loading the item’s preview…",
  /** The split check lists an item the story's canvas doesn't return. */
  noPreview: "No preview for this item.",
  /** Under the tally when a chart or table is drawn: they show the whole story, not one copy. */
  storyNumbers: "Charts and tables show the story’s own numbers.",
} as const;

/** Step 1's section titles and the value grid's controls (F09). The field's own word comes from the field. */
export const SPLIT_STEP_COPY = {
  fieldHeading: "One copy per",
  fieldPlaceholder: "Choose a field",
  fieldLoading: "Loading fields…",
  valuesHeading: (fieldPlural: string) => `${fieldPlural} that get a copy`,
  filterLabel: "Show values",
  filterAll: "All",
  filterIncluded: "Included",
  filterNoData: (count: number) => (count ? `No data · ${count}` : "No data"),
  noData: "No data",
  showAll: (count: number) => `Show all ${count}`,
  policySkip: "Skip it",
  policyHold: "Hold and remind me",
} as const;

/** The shared empty state for a story with nothing to split by (Simple and Advanced step 1). Neutral: no tenant values. */
export const NO_SPLIT_FIELD_COPY = {
  title: "Nothing in this story can split it yet",
  body: "Add a chart or table that has a field like a region or an account, then come back.",
  action: "Open the story",
  retry: "Try again",
} as const;
